import React from 'react';
import { useMutation } from '@tanstack/react-query';
import axios from './../../../../utils/oc-axios';
import { Group, GroupMutationsVariables, GroupMutationCallback } from '../Groups.types';
import useAlert, { AlertPriorityTypes } from '../../../../hooks/useAlert';
import { AlertDispatch } from '../../../../hooks/useAlert/types.useAlert';

const useDeleteGroup = (cb?: GroupMutationCallback) => {
	const notification = useAlert()[1] as AlertDispatch;

	/**
     * Deletes a group
     * 
     * @param {Group} group
     * @returns {Promise<void>}
     */
	const deleteGroup = React.useCallback(async (group: Group): Promise<void> => {
		return axios.delete(`modules/groups/${group?.id}`)
			.then(res => res.data)
			.catch((error) => {
				throw new Error(error);
			});
	}, []);

	// Returns a mutation object in order to deleta a group,
	// Optional: provide it with an alertId to use with notifications and closeModal method to close the modal
	// When provided they can be accessed in onSuccess or onError methods of the mutation object
	const mutation = useMutation((variables: GroupMutationsVariables) => {
		return deleteGroup(variables.group);
	}, {
		onSuccess(_data, variables) {
			if(variables.alertId) {
				notification('MODIFY', {
					alertID: variables.alertId,
					priority: AlertPriorityTypes.success,
					title: 'Grupp borttagen',
					children: `Gruppen ${variables.group.name} har nu bilvit borttagen.`
				});
			}

			// Call the callback method provided to the hook if given
			if(cb) cb(variables.group, true);

			// Call a callback from variables if such method is provided
			if(variables.cb) variables.cb();
		},
		onError(_error, variables) {
			if(variables.alertId) {
				notification('MODIFY', {
					alertID: variables.alertId,
					priority: AlertPriorityTypes.error,
					title: 'Ett fel har uppstått',
					children: `Det gick inte att ta bort gruppen ${variables.group.name}.`
				});
			}
		}
	});

	return mutation;
};

export default useDeleteGroup;